// DenTabulaMobile.jsx — „Dnes“ na mobile: spoločná tabuľa dňa (mojden_v3, 29. 9. 2026). Mirko: body spoločné pre všetkých — office A TECHNIK
// (chýba materiál, zvoz materiálu, kam potrebujeme šoféra dnes, priority). Rovnaké dáta ako na počítači (GET /api/mojden → tabula),
// preto druhý register nevzniká (0.J): body sú karty NEO zdroj 'tabula'. Hinty 12.0/4: pod nadpisom je vysvetlené, čo tabuľa je a kto ju vidí.
import React, { useState, useEffect, useCallback } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'
import { COLORS, TYPO, SPACE, RADIUS } from '../theme.js'
import { useToast } from '../components/Toast.jsx'

const KAT = { sofer: 'Šofér', chyba: 'Chýba materiál', zvoz: 'Zvoz / odvoz', priorita: 'Priorita dňa', info: 'Info pre všetkých' }
const KAT_C = { sofer: COLORS.brand, chyba: COLORS.remove, zvoz: COLORS.info, priorita: COLORS.warn, info: COLORS.muted }

export default function DenTabulaMobile() {
  const toast = useToast()
  const [md, setMd] = useState(null)
  const [chyba, setChyba] = useState('')
  const [novy, setNovy] = useState(false)
  const [kat, setKat] = useState('chyba')
  const [text, setText] = useState('')
  const [busy, setBusy] = useState(false)

  const load = useCallback(() => {
    fetchAuth('/api/mojden').then(async r => { const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.error || ('HTTP ' + r.status)); return j })
      .then(x => { setMd(x); setChyba('') }).catch(e => setChyba(e.message || 'server neodpovedá'))
  }, [])
  useEffect(() => { load(); const t = setInterval(load, 120000); return () => clearInterval(t) }, [load])

  const pridaj = async () => {
    if (!text.trim()) { toast.warn('Napíš, čo treba'); return }
    setBusy(true)
    try {
      const r = await fetchAuth('/api/mojden/tabula', { method: 'POST', body: JSON.stringify({ kategoria: kat, text: text.trim() }) })
      const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.error || 'Nepodarilo sa uložiť')
      setText(''); setNovy(false); toast.success('Na tabuli — vidí office, koordinátorka aj konateľ'); load()
    } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  const akcia = async (id, a) => {
    setBusy(true)
    try { const r = await fetchAuth('/api/mojden/tabula/' + id + '/' + a, { method: 'POST' }); const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.error || 'Nepodarilo sa')
      toast.success(a === 'beriem' ? 'Berieš to — ostatní vidia tvoje meno' : 'Hotovo — vidia všetci'); load() } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }

  const tab = (md && md.tabula) || []
  const otv = tab.filter(t => !t.hotovo_at); const hot = tab.filter(t => t.hotovo_at)
  const S = { card: { background: '#fff', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: '10px 12px', marginBottom: 8 },
    btn: { background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: '10px 14px', fontSize: TYPO.sizes.sm, fontFamily: 'inherit', minHeight: 44, cursor: 'pointer' } }
  return (
    <div style={{ padding: SPACE.md, fontFamily: 'inherit', color: COLORS.text }}>
      <h2 style={{ margin: '0 0 2px', fontSize: 20 }}>Dnes pre všetkých</h2>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 10, lineHeight: 1.45 }}>
        Jedna tabuľa na dnešný deň — rovnakú vidí office, koordinátorka aj konateľ. Píš sem, čo chýba, čo treba odviezť alebo doviezť, kam treba šoféra a čo dnes horí.
        Keď niečo zoberieš na seba, stlač <b>Beriem</b>; keď je to vybavené, <b>Hotovo</b>. Každý bod nesie tvoje meno a čas.
      </div>
      {chyba ? <div style={{ ...S.card, borderColor: COLORS.remove, color: COLORS.remove }}>Tabuľu sa nepodarilo načítať: {chyba}</div> : null}
      {md && md.tabula_pis ? (
        novy ? (
          <div style={{ ...S.card, borderColor: COLORS.brand }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
              {Object.keys(KAT).map(k => (
                <button key={k} onClick={() => setKat(k)} style={{ ...S.btn, minHeight: 40, padding: '8px 10px', background: kat === k ? KAT_C[k] : COLORS.bgSoft, color: kat === k ? '#fff' : COLORS.text, borderColor: kat === k ? KAT_C[k] : COLORS.line, fontWeight: kat === k ? 700 : 400 }}>{KAT[k]}</button>
              ))}
            </div>
            <textarea value={text} onChange={e => setText(e.target.value)} rows={3} placeholder="napr. Lomnička — chýba 10 vriec lepidla, treba do zajtra 7:00"
              style={{ width: '100%', boxSizing: 'border-box', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: 10, fontSize: TYPO.sizes.md, fontFamily: 'inherit' }} />
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button disabled={busy} onClick={pridaj} style={{ ...S.btn, flex: 1, background: COLORS.add, color: '#fff', borderColor: COLORS.add, fontWeight: 700 }}>Pridať na tabuľu</button>
              <button disabled={busy} onClick={() => { setNovy(false); setText('') }} style={{ ...S.btn }}>Zrušiť</button>
            </div>
          </div>
        ) : <button onClick={() => setNovy(true)} style={{ ...S.btn, width: '100%', background: COLORS.nav, color: '#fff', borderColor: COLORS.nav, fontWeight: 700, marginBottom: 10 }}>+ Napísať bod pre všetkých</button>
      ) : null}
      {!md ? <div style={{ color: COLORS.muted }}>Načítavam…</div> : null}
      {md && tab.length === 0 ? <div style={{ ...S.card, color: COLORS.muted }}>Na dnes tu zatiaľ nič nie je.</div> : null}
      {[...otv, ...hot].map(t => (
        <div key={t.id} style={{ ...S.card, borderLeft: `4px solid ${t.hotovo_at ? COLORS.add : (KAT_C[t.kategoria] || COLORS.muted)}`, opacity: t.hotovo_at ? 0.6 : 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4, flexWrap: 'wrap' }}>
            <span style={{ fontSize: TYPO.sizes.xs, fontWeight: 800, color: KAT_C[t.kategoria] || COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>{KAT[t.kategoria] || 'Info'}</span>
            {t.priorita && !t.hotovo_at ? <span style={{ color: COLORS.remove, fontWeight: 900 }}>!</span> : null}
            {t.vcera ? <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.warn, fontWeight: 700 }}>od včera</span> : null}
            {t.hotovo_at ? <span style={{ marginLeft: 'auto', fontSize: TYPO.sizes.xs, fontWeight: 800, color: COLORS.add }}>hotovo {t.hotovo_at}</span> : null}
          </div>
          <div style={{ fontSize: TYPO.sizes.md, lineHeight: 1.4, textDecoration: t.hotovo_at ? 'line-through' : 'none' }}>{t.text}</div>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 4 }}>rieši <b>{t.riesi}</b> · zadal {t.zadal} · {t.cas}</div>
          {!t.hotovo_at ? (
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button disabled={busy} onClick={() => akcia(t.id, 'beriem')} style={{ ...S.btn, flex: 1 }}>Beriem</button>
              <button disabled={busy} onClick={() => akcia(t.id, 'hotovo')} style={{ ...S.btn, flex: 1, background: COLORS.add, color: '#fff', borderColor: COLORS.add, fontWeight: 700 }}>Hotovo</button>
            </div>
          ) : null}
        </div>
      ))}
    </div>
  )
}
